import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getFilters } from "../../api/filtersApi";

const initialState = {
  items: [],
  status: "",
  error: "",
  searchString: "",
  isUpdatedFromUrl: false,
};

export const fetchFilters = createAsyncThunk(
  "filters/fetchFilters",
  async function (_, { rejectWithValue, getState }) {
    try {
      const filterGroups = getState().filters.items;
      const nodeAliasPath = getState().settings.nodeAliasPath;
      const lang = getState().settings.lang;
      const isKidsApp = getState().settings.isKidsApp;

      const payload = {
        nodeAliasPath,
      };
      if (filterGroups.length) {
        payload["filterGroups"] = filterGroups;
      }
      const response = await getFilters({
        payload,
        lang,
        isKidsApp,
      });
      return response || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.items = action.payload;
    },
    updateFilter: (state, action) => {
      const { groupName, filter } = action.payload;
      const filterGroup = state.items.find((group) => group.name === groupName);
      const changedFilterIndex = filterGroup.filters.findIndex(
        (filterItem) => filterItem.id === filter.id
      );
      filterGroup.filters[changedFilterIndex] = filter;
    },
    updateSearchString: (state, action) => {
      const filterGroups = state.items;
      const { currentPage } = action.payload;
      const queryParams = {
        page: currentPage,
      };

      filterGroups.forEach((filterGroup) => {
        if (filterGroup.name === "search") {
          if (filterGroup.filters[0] && filterGroup.filters[0].value !== "") {
            queryParams[filterGroup.name] = filterGroup.filters[0].value;
          }
        } else {
          const selectedFilters = filterGroup.filters.filter(
            (item) => item?.selected
          );
          if (selectedFilters.length > 0) {
            queryParams[filterGroup.name] = selectedFilters.map(
              (filter) => filter.id
            );
          }
        }
      });

      state.searchString = new URLSearchParams(queryParams).toString();
    },
    updateFiltersBySearchParams: (state) => {
      const filterGroups = state.items;

      if (!filterGroups.length) {
        return;
      }
      state.isUpdatedFromUrl = true;

      const urlSearchParams = new URLSearchParams(window.location.hash);
      const params = {};
      for (let [key, value] of urlSearchParams.entries()) {
        if (key.includes("page")) {
          key = "page";
        }
        params[key] = value.split(",");
      }

      for (let key of Object.keys(params)) {
        if (key === "page") {
          continue;
        }

        params[key].forEach((paramValue) => {
          const filterGroup = filterGroups.find((group) => group.name === key);
          if (key === "search") {
            if (filterGroup.filters && filterGroup.filters[0]) {
              filterGroup.filters[0].value = paramValue;
            }
          } else {
            const filter = filterGroup.filters.find(
              (filter) => filter.id === paramValue
            );
            if (filter) {
              filter.selected = true;
            }
          }
        });
      }
    },
    setIsUpdatedFromUrl: (state, action) => {
      state.isUpdatedFromUrl = action.payload;
    },
    resetFilterGroup: (state, action) => {
      const { groupName } = action.payload;
      const filterGroup = state.items.find((group) => group.name === groupName);

      if (filterGroup.name === "search") {
        filterGroup.filters.forEach((element) => {
          element.value = "";
        });
      } else {
        filterGroup.filters.forEach((element) => {
          element.selected = false;
        });
      }
    },
    resetAllFilters: (state) => {
      state.items.forEach((group) => {
        group.filters.forEach((filter) => {
          if (group.name === "search") {
            filter.value = "";
          } else {
            filter.selected = false;
          }
        });
      });
    },
  },
  extraReducers: {
    [fetchFilters.pending]: (state) => {
      state.status = "loading";
      state.error = null;
    },
    [fetchFilters.fulfilled]: (state, action) => {
      state.status = "resolved";
      state.items = action.payload;
    },
    [fetchFilters.rejected]: (state, action) => {
      state.status = "rejected";
      state.error = action.payload;
    },
  },
});

export const {
  setFilters,
  updateFilter,
  updateSearchString,
  updateFiltersBySearchParams,
  setIsUpdatedFromUrl,
  resetFilterGroup,
  resetAllFilters,
} = filterSlice.actions;

export default filterSlice.reducer;
